export const serverErrorMessage = errorBody => {
  const candidates = [
    errorBody,
    errorBody?.msg,
    errorBody?.err,
    errorBody?.error,
    errorBody?.message
  ];

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate.trim();
    }
    if (
      candidate &&
      typeof candidate.message === 'string' &&
      candidate.message.trim()
    ) {
      return candidate.message.trim();
    }
  }

  return undefined;
};
